export default __webpack_public_path__ + "static/media/whitewall-logo-color_xxl.80e97dbd.png";